import { SvgIcon } from "@mui/material";
import React from "react";

const ShelfIcon = (props) => {
	return (
		<SvgIcon {...props} viewBox="0 0 512 512">
			<svg fill="rgba(0, 0, 0, 0.54)">
				<path d="M422 0v150.75H90V0H0v512h90V391.5h332V512h90V0zM90 361.5V180.75h332V361.5z" />
				<path d="M120.25 210.75H241V331.5H120.25zM271 210.75h120.75V331.5H271zM120.25 0H241v120.75H120.25zM271 0h120.75v120.75H271z" />
			</svg>
		</SvgIcon>
	);
};
export default ShelfIcon;
